import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
// import Button from 'react-bootstrap/Button';
import logo from '../sources/images/everybill-logo-ko.svg';
import arrowImg from '../sources/images/arrow.png';

import ReactGa from  'react-ga';

// import {Redirect} from 'react-router-dom';

// import routes from '../routes';

export default class NavBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            home: '/home',
            about: '/about',
            solutions: '/solutions',
            resources: '/resources',
            techSpecs: '/technical-specifications',
            contact: '/contact',
            search: '/search',
            demo: '/demo',
            portal: '/automated-consumer-portal',
            selfpay: '/self-pay-websites',
            automated: '/automated-phone-systems',
            showDropdown: false,
            currentNav: '',
            previousNav: '',
            requestDemo: false
        };

        this.requestDemo = this.requestDemo.bind(this);
        this.displayDropdown = this.displayDropdown.bind(this);
    }

    componentDidMount() {
        console.log('NavBar did load');
    }

    requestDemo(e) {
        console.log(e);
        ReactGa.event({
            category: 'Button',
            action: 'Requesting Demo'
        })
    }

    displayDropdown(route) {
        if(this.state.showDropdown === true) {
            if(this.state.currentNav === route) {
                this.setState({showDropdown: !this.state.showDropdown});
            } else {
                this.setState({currentNav: route});
            }
        } else {
            this.setState({showDropdown: !this.state.showDropdown, currentNav: route});
        }
    }

    render() {
        return (
            <div>
                <div className="custom-navbar">
                    <Navbar variant="dark" expand="lg" style={{ padding: '26px', paddingTop: '16px', paddingBottom: '16px', backgroundColor: '#000' }}>
                        <Navbar.Brand style={{ color: 'white' }} href="/">
                            <img className="logo" src={ logo } alt=""/>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" style={{padding: 'unset', height: '52px'}}/>
                        <Navbar.Collapse id="basic-navbar-nav" className="navContainer">
                            <Nav className="mr-auto">
                                {/* <Nav.Link style={{ color: 'black' }} href={this.state.home}><strong>HOME</strong></Nav.Link> */}
                                {/* <Nav.Link style={{ color: 'black' }} href={this.state.about}><strong>ABOUT</strong></Nav.Link> */}
                                {/* <Nav.Link style={{ color: 'black' }} href={this.state.solutions} onClick={() => this.displayDropdown('Solutions')}><strong>SOLUTIONS</strong></Nav.Link> */}
                                {/*<Nav.Link style={{ color: 'black' }} href={this.state.resources}>Resources</Nav.Link>*/}
                                {/* <Nav.Link style={{ color: 'black' }} href={this.state. contact}><strong>CONTACT</strong></Nav.Link> */}
                                {/*<Nav.Link style={{ color: 'black' }} href={this.state.search}>Search</Nav.Link>*/}
                                {/* <Nav.Link className="ebBtn" href={this.state.home}>REQUEST DEMO</Nav.Link> */}
                            </Nav>
                            <div className="ebLinkContainer mobile-hidden">
                                <a className="ebLink" href={this.state.about}><strong>ABOUT</strong></a>
                            </div>
                            <div className="ebLinkContainer mobile-hidden">
                                <span className="ebLink" onClick={() => this.displayDropdown('Solutions')}><strong>SOLUTIONS</strong></span>
                            </div>
                            <div className="ebLinkContainer mobile-hidden">
                                <a className="ebLink" href={this.state.techSpecs}><strong>TECHNICAL SPECS</strong></a>
                            </div>
                            <div className="ebLinkContainer mobile-hidden">
                                <a className="ebLink" href={this.state.contact}><strong>CONTACT</strong></a>
                            </div>
                            <div className="ebBtnContainer mobile-hidden">
                                <a className="ebBtn" onClick={this.requestDemo} href={this.state.demo}><strong>REQUEST DEMO</strong></a>
                            </div>
                            <div className="mobile-show">
                                {
                                    !this.state.showDropdown &&
                                    <div>
                                        <div className="ebLinkContainer">
                                            <a className="ebLink" href={this.state.about}><strong>ABOUT</strong></a>
                                        </div>
                                        <div className="ebLinkContainer">
                                            <span className="ebLink" onClick={() => this.displayDropdown('Solutions')}><strong>SOLUTIONS</strong></span>
                                        </div>
                                        <div className="ebLinkContainer">
                                            <a className="ebLink" href={this.state.contact}><strong>CONTACT</strong></a>
                                        </div>
                                        <div className="ebBtnContainer">
                                            <a className="ebBtn" onClick={this.requestDemo} href={this.state.demo}><strong>REQUEST DEMO</strong></a>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div>
                                <div className="mobile-show">
                                    {
                                        this.state.showDropdown && this.state.currentNav === 'Solutions' &&
                                        <div>
                                            <div className="ebLinkContainer">
                                                <span className="ebLinkBackBtn" onClick={() => this.displayDropdown('Solutions')}>
                                                    <img style={{width: '10px', height: '10px', marginRight: '10px'}} src={ arrowImg } alt=""/>
                                                    <strong>BACK</strong>
                                                </span>
                                            </div>
                                            <div style={{color: '#FFF', fontSize: '18px'}}>
                                                <strong>SOLUTIONS</strong>
                                            </div>
                                            <div className="ebLinkContainer" style={{paddingLeft: '10px'}}>
                                                <a className="sub-nav-item" href={this.state.portal}><strong>AUTOMATED CONSUMER PORTAL</strong></a>
                                            </div>
                                            <div className="ebLinkContainer" style={{paddingLeft: '10px'}}>
                                                <a className="sub-nav-item" href={this.state.selfpay}><strong>SELF-PAY WEBSITES</strong></a>
                                            </div>
                                            <div className="ebLinkContainer" style={{paddingLeft: '10px'}}>
                                                <a className="sub-nav-item" href={this.state.automated}><strong>AUTOMATED PHONE SYSTEMS</strong></a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </Navbar.Collapse>
                    </Navbar>
                    <div className="mobile-hidden">
                    
                        {
                            this.state.showDropdown && this.state.currentNav === 'Solutions' &&
                            <div className="subNav solutions arrow-top">
                                <div>
                                    <div className="alignRow">
                                        <div className="subNavItemContainer">
                                        <a className="sub-nav-item" href={this.state.portal}><strong>AUTOMATED CONSUMER PORTAL</strong></a>
                                            <div className="mobile-show">
                                                <hr></hr>
                                            </div>
                                            <a className="sub-nav-item" href={this.state.selfpay}><strong>SELF-PAY WEBSITES</strong></a>
                                            <div className="mobile-show">
                                                <hr></hr>
                                            </div>
                                            <a className="sub-nav-item" href={this.state.automated}><strong>AUTOMATED PHONE SYSTEMS</strong></a>
                                        </div>
                                        {/* <div className="subNavItemContainer"><a className="subNavItem" style={{color: 'black'}} href={this.state.automated}><strong>Automated phone systems</strong></a></div> */}
                                    </div>
                                </div>
                            </div>
                        }
                        {/*
                            this.state.showDropdown && this.state.currentNav == 'Resources' &&
                            <div className="subNav resources arrow-top">
                                <div className="alignRow">
                                    <div className="subNavItemContainer"><a className="subNavItem" style={{color: 'black'}} href={this.state.resources}>Test sub-menu</a></div>
                                </div>
                            </div>
                        */}
                    </div>
                </div>
            </div>
        )
    }
}
